import { requests } from "../../../api/agent"

const api = {
    getAnalogProjects: (values) => requests.post('/JsonLine/GetAnalogProjects', values),
    getAnalogObjects: (values) => requests.getWithParams('/JsonLine/GetAnalogObjects', values),
    getAnalogProjectById: (values) => requests.getWithParams('/JsonLine/GetAnalogProjectById', values),
    getObjectSmetas: (values) => requests.getWithParams('/JsonLine/GetObjectSmetas', values),
    getSmetas: (values) => requests.getWithParams('/JsonLine/GetSmetas', values),
    getPrices: (values) => requests.getWithParams('/JsonLine/GetPrices', values),
    getResources: (values) => requests.getWithParams('/JsonLine/GetResources', values),
    getLimitedCosts: (values) => requests.getWithParams('/JsonLine/GetLimitedCosts', values),
    UploadJsonLines: (values) => requests.post('/JsonLine/UploadJsonLines', values),
    UploadObjectFiles: (values) => requests.post('/jsonLine/UploadObjectFiles', values),
    deleteAnalogProjects: (values) => requests.post('/JsonLine/DeleteAnalogProject', values),
    getPagePriceByProjectId: (values) => requests.getWithParams('/Constructor/getPagePriceByProjectId', values),
    savePtmDescription: (values) => requests.post('/Constructor/savePtmDescription', values),
    getSchemas: (params) => requests.getWithParams('/JsonLine/getSchemas', params),
    createObjCharacteristic: (values) => requests.post('/AObject/CreateObjCharacteristic', values),
    getAnalogObjectsByProjectId: (values) => requests.getWithParams('/AObject/GetAnalogObjectsByProjectId', values),
    getAllPtmByObjectId: (params) => requests.getWithParams('/aObject/getAllPtmByObjectIdForCost', params),
    getAllPtmDescriptionByObjectId: (params) => requests.getWithParams('/aObject/getAllPtmDescriptionByObjectIdForCost', params),
    getSummaryCosts: (params) => requests.post('/Analytics/getSummaryCosts', params),
    getMinMaxCosts: (params) => requests.post('/Analytics/getMinMaxCosts', params),
    getExplications: (params) => requests.getWithParams('/JsonLine/getExplications', params),
    getAllProjectFiles: (params) => requests.getWithParams('/JsonLine/getAllProjectFiles', params),
    updateAnalogObject: (params) => requests.post('/AnalogProject/UpdateAnalogObject', params),
    updateAnalogObjectFiles: (params) => requests.post('/AnalogProject/UpdateAnalogObjectFiles', params),
}

export default api